<div class="displayFlexColumn">
 
    <!-- header  -->
    <div class="displayFlexSpaceBetween">
      <div class="fs-16 font-weight-700">
        <span>List Of Passengers</span>
        <span>
            <div *ngIf="riderLimit && riderLimit>0" class=" fs-12 geoaraea-label displayFlex align-item-flex-start mt-8">
                 You can add upto {{riderLimit}} passenger(s)
            </div>
        </span>
      </div>
      <div class="displayFlex" style="height: 30px;">
        <div *ngIf="whatsappComm" class="displayFlex align-item-center watsappComm mr-16">
            <mis-checkbox
              [type]="'Default'"
              [checked]="false"
              (valueChange)="onWhatsappCheck($event)"
              [name]="'whatsapp'"
              [checked]="whatsappCommunication"
            ></mis-checkbox>
            <span class="ml-8 fs-12 displayFlex align-item-center"
              >Receive trip details on
              <img src="assets/Digital_Inline_Dark_Green 1.svg" alt="" class="ml-4"/>
            </span>
        </div>
        <div *ngIf="addRiderConfig && addRiderConfig.visibility" (click)="addPassenger()" class="displayFlex add-rider"  [ngClass]="{'disabled':formArray.length==riderLimit}">
            <span class="displayFlex align-item-center">
                <img src="assets/bulk.svg" alt="" class="mr-4" style="width: 16px;">
                <span class="fs-14 font-weight-700 text-primary"> {{ addRiderConfig.displayName}}</span>
            </span>
        </div>
      </div>
    </div>

  <!-- table  -->
    <div>
        <div class="table-content">
            <table class="riderStaticTable">
                <thead>
                    <tr>
                        <ng-container *ngFor="let field of addRiderService.formConfig">
                            <ng-container *ngIf="field.config.showInStaticTable">
                                <th>
                                    <span>{{field.config.displayName}}</span>
                                </th>
                            </ng-container>
                        </ng-container>
                        <th>Actions</th>
                    </tr>
                </thead>
                <tbody>
                    <tr *ngFor="let rider of formArray.controls; let i = index;">
                        <ng-container *ngFor="let field of addRiderService.formConfig">

                            <ng-container [ngSwitch]="field.elementKey">
                                <td *ngSwitchCase="'riderType'">
                                    <span class="fs-10 font-weight-700" [ngClass]="field.elementKey=='riderType' && rider.get('riderTypeId')?.value=='Firm Member' ? 'firmRiderType' :  
                                    field.elementKey=='riderType' && rider.get('riderTypeId')?.value=='Self'? 'selfRiderType' : 'guestRiderType'">
                                      {{rider.get(field.elementKey)?.value || '--'}}  
                                    </span>
                                </td>
                                <ng-container *ngSwitchCase="'mobile'">
                                  <td *ngIf="field.config.showInStaticTable">
                                    {{rider.get('phoneCode')?.value }} {{ (rider.get('mobile')?.value  | formatPhoneNumber : rider.value)  || '--'}}
                                  </td>
                                </ng-container>
                                <ng-container *ngSwitchCase="'alternateMobile'">
                                    
                                    <td *ngIf="field.config.showInStaticTable">
                                          {{rider.get('alternatePhoneCode')?.value ? rider.get('alternatePhoneCode')?.value : '+91' }}  {{ (rider.get('alternateMobile')?.value | formatPhoneNumber : rider.value) || '--'}}
                                    </td>
                                  </ng-container>
                                <ng-container *ngSwitchDefault>
                                  <td *ngIf="field.config.showInStaticTable">{{rider.get(field.elementKey)?.value || '--'}}  </td>
                                </ng-container>
                              </ng-container>
                           
                        </ng-container>
                        <td>
                            <span class="mr-10 cursor-pointer" (click)="addPassenger(rider,true)"><img src="assets/ic-action-edit-16.svg" alt=""></span>
                            <span class="cursor-pointer" (click)="onDeleteClick(i)"><img src="assets/ic-action-delete-24.svg" alt=""></span>
                            <span *ngIf="!rider.valid" [matTooltip]="'Incomplete Details'" matTooltipClass="booking-table-tooltip" class="float-right"> <img src="assets/ic-ui-error-24.svg" alt=""></span>
                        </td>
                       
                    </tr>
                </tbody>
             </table>
        </div>
   
    </div>
</div>


<ng-template [ngIf]="addRiderService.showDuplicateRiderError">
  <div class=" ava-snackbar">
      <span><img src="assets/ic-ui-error-24.svg" alt="error"></span>
      {{addRiderService.duplicateRiderMsg}}
  </div>
</ng-template>


<ng-container>

</ng-container>



